import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Devo essere un musicista per usare Musica Pronta?',
  answer: 'No. Ogni volume è pensato anche per chi non ha una formazione musicale specifica, con spiegazioni chiare e materiali pronti passo-passo.'
}, {
  question: 'Per quali classi è adatto?',
  answer: "Copre l'intero primo ciclo: dalla 1ª classe della primaria alla 3ª media (età 6-14 anni)."
}, {
  question: 'Ricevo un file fisico o digitale?',
  answer: "Digitale: ricevi tutti i PDF pronti da stampare o usare su schermo, con accesso immediato dopo l'acquisto."
}, {
  question: 'È allineato al programma ministeriale?',
  answer: "Sì, i contenuti sono allineati alle Nuove Indicazioni Nazionali per l'educazione musicale."
}, {
  question: 'Posso usarlo anche a casa con mio figlio?',
  answer: 'Sì, il percorso è pensato per insegnanti ma è altrettanto utile per genitori che vogliono affiancare i propri figli.'
}, {
  question: 'Cosa succede se non mi piace?',
  answer: 'Hai 30 giorni di garanzia soddisfatti o rimborsati, senza domande.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-72" data-mp="1fmsqsdq5p9nq">
      <div className="mx-auto max-w-3xl" data-id="element-73" data-mp="11wyz7nn9obab">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-74" data-mp="11v5sy9gkft2u">
          Buono a sapersi
        </p>
        <h2 className="mt-4 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-75" data-mp="rzud1ntf8fti">
          Domande Frequenti
        </h2>

        <div className="mt-10 space-y-3" data-id="element-76" data-mp="ww1lpod7c5f5">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-navy/10 bg-white" data-id="element-77" data-mp="n0807fhi91l8" data-mpi={index}>
                <h3 data-id="element-78" data-mp="2pogdtiinssbb">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-navy" data-id="element-79" data-mp="2kw6n409pzo7z">
                    <span className="text-[15px] font-semibold text-navy sm:text-base" data-id="element-80" data-mp="33kboj12wmx3m">
                      {faq.question}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} className="flex-none text-orange" data-id="element-81" data-mp="2umhujwsm4fjm">
                      <ChevronDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-82" data-mp="1j8nu2o6a3gp0" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-83" data-mp="2r5k5otnnvjl">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-84" data-mp="7oyp6ej82jia">
                      <p className="px-6 pb-6 text-[15px] leading-relaxed text-ink-soft" data-id="element-85" data-mp="mfxvfiwl4vyp">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}